import { mountGenerateApp } from './generate-app';
import { mountSplitApp } from './split-app';

export function mountApp(root: HTMLElement): void {
  root.innerHTML = `
    <header class="app-header">
      <div>
        <h1>Image → APNG</h1>
        <p class="tagline">伪静态防闪 · 封面伪装 · 纯浏览器本地处理</p>
      </div>
      <span class="badge" title="图片不会离开本机">🔒 本地处理 · 不上传</span>
    </header>
    <nav class="tabs" role="tablist" aria-label="工具模式">
      <button type="button" class="tab active" id="tab-generate" role="tab" aria-selected="true">生成 APNG</button>
      <button type="button" class="tab" id="tab-split" role="tab" aria-selected="false">解帧 / 拆分</button>
    </nav>
    <main id="tool-view" aria-live="polite"></main>
    <footer class="app-footer">所有处理均在浏览器本地完成，不上传文件。</footer>
  `;

  const view = root.querySelector('#tool-view') as HTMLElement;
  const generateTab = root.querySelector('#tab-generate') as HTMLButtonElement;
  const splitTab = root.querySelector('#tab-split') as HTMLButtonElement;
  let cleanup: (() => void) | null = null;

  function show(tab: 'generate' | 'split'): void {
    cleanup?.();
    view.replaceChildren();
    cleanup = tab === 'generate' ? mountGenerateApp(view) : mountSplitApp(view);
    generateTab.classList.toggle('active', tab === 'generate');
    splitTab.classList.toggle('active', tab === 'split');
    generateTab.setAttribute('aria-selected', String(tab === 'generate'));
    splitTab.setAttribute('aria-selected', String(tab === 'split'));
  }

  generateTab.addEventListener('click', () => show('generate'));
  splitTab.addEventListener('click', () => show('split'));
  show('generate');
}
